/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Picker_YesterdayInputs */

const fr_date_picker_yesterday = /** @type {(inputs: Date_Picker_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier`)
};

const en_date_picker_yesterday = /** @type {(inputs: Date_Picker_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Date_Picker_YesterdayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_picker_yesterday = /** @type {((inputs?: Date_Picker_YesterdayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Picker_YesterdayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_date_picker_yesterday(inputs)
	return fr_date_picker_yesterday(inputs)
});